export default {
  namespaced: true,
  state: {
    automobiles: [],
    isAutomobilesLoading: false,
    page: 0,
  },
  getters: {
    getAutomobilesList(state) {
      return state.automobiles;
    },
    getAutomobilesLoading(state) {
      return state.isAutomobilesLoading;
    },
    getPage(state) {
      return state.page;
    },
  },
  mutations: {
    setAutomobilesList(state, payload) {
      state.automobiles = payload;
    },
    setAutomobilesLoading(state, payload) {
      state.isAutomobilesLoading = payload;
    },
    setPage(state, payload) {
      state.page = payload;
    },
  },
  actions: {
    setAutomobilesList({ commit }, payload) {
      commit('setAutomobilesList', payload);
    },
  },
};
